import type { InfoAccordionsProps } from '/site/parts/info-accordions/info-accordions.d';

import React from 'react';
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@hdir/ui/accordion';
import Richtext from '/react4xp/shared/Richtext/Richtext';


export function InfoAccordions(props: InfoAccordionsProps): JSX.Element {
	const {
		accordions,
		title,
	} = props;

	return (
		<section className="py-xl">
			<div className="grid grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-3 gap-md tablet:gap-xl">
				<h2 className="text-xxl font-bold">{title}</h2>
				<div className="col-span-2 flex flex-col gap-md tablet:gap-xl w-full">
					{accordions.map((accordion, accordionIndex) => (
						<Accordion key={accordionIndex}>
							<AccordionItem>
								<AccordionTrigger>
									<span className="mr-md !text-neutral">{accordion.title}</span>
								</AccordionTrigger>
								<AccordionContent>
									<Richtext className='text-lg' text={accordion.text} />
								</AccordionContent>
							</AccordionItem>
						</Accordion>
					))}
				</div>
			</div>
		</section>
	);
}
